exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".orders-date-picker[data-v-e1822dec]{margin-top:1px}", ""]);

// exports
